export class GcpMachineTypesResponse {
    'machineTypes';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "machineTypes",
            "baseName": "machineTypes",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpMachineTypesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
